module.exports = __webpack_public_path__ + "static/media/large-box.91395a94.svg";